import React from 'react';
import { RouteObject } from 'react-router-dom';
import { ComparisonPage } from '../pages/comparison-page/ComparisonPage';
import { GetListedPage } from '../pages/GetListedPage';
import { BusinessListPage } from '../pages/business-listing/BusinessListPage';
import { LoginPage } from '../pages/LoginPage';
import { ProtectedRoute } from '../components/ProtectedRoute';
import { DashboardPage } from '../pages/dashboard/DashboardPage';
import NotFoundPage from '../pages/NotFoundPage';
import { UserType } from '../data/types/auth';
  
export const routes: RouteObject[] = [
  {
    path: '/',
    element: <ComparisonPage />,
  },
  {
    path: '/get-listed',
    element: <GetListedPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute allowedUserTypes={[UserType.BUSINESS, UserType.SUPER_ADMIN]}>
        <DashboardPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/manage-business',
    element: (
      <ProtectedRoute allowedUserTypes={[UserType.SUPER_ADMIN]}>
        <BusinessListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

// Navigation items for the app bar
export const navigationItems = [
  {
    path: '/',
    label: 'Compare',
  },
  {
    path: '/get-listed',
    label: 'Get Listed',
  },
];

// Navigation items for authenticated users
export const authenticatedNavigationItems = [
  {
    path: '/manage-business',
    label: 'Manage Businesses',
  },
];

// Navigation items for non-authenticated users
export const nonAuthenticatedNavigationItems = [
  {
    path: '/login',
    label: 'Login',
  },
];

// Navigation items for Super Admin only
export const adminNavigationItems = [
  {
    path: '/manage-business',
    label: 'Manage Businesses',
  },
]; 